import { useEffect } from "react";

import { useSearchParameters } from "@/components/signup/hooks/use-search-parameters.tsx";
import { useScreenManager } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-screen-manager";
import { isTeamTypeWithJtbd } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/utils/screen-manager/utils";

import { JiraOverlayShim } from "../onboarding-wizard/wizard/jira-overlay-shim";

import JtbdView from "./jtbd-view";

export const TwcJtbdView = () => {
    const { skipScreen } = useScreenManager();
    const { teamType } = useSearchParameters();

    const shouldSkipScreen = !isTeamTypeWithJtbd(teamType);

    useEffect(() => {
        if (shouldSkipScreen) {
            skipScreen();
        }
    }, [shouldSkipScreen, skipScreen]);

    if (shouldSkipScreen) {
        return null;
    }

    return (
        <JiraOverlayShim>
            <JtbdView />
        </JiraOverlayShim>
    );
};
